import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';

export const useFetchAllAuthorities = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [dataAuthorities, setDataAuthorities] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllAuthorities, setLoadingFetchAllAuthorities ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/legal/fetch-all-authorities`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllAuthorities(true)
        fetchData()
            .then((resp) => {
                setDataAuthorities(resp.rows)
                setLoadingFetchAllAuthorities(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllAuthorities(false)
            })
    }, [execute])

    return { dataAuthorities, loadingFetchAllAuthorities, executeFetch }

}

export const useFetchSpecificAuthority = ({marvarApi, dispatch, onLogout, Forms}) => {

    // 1. Para los datos recuperados de la BD
    // const [infoClient, setInfoClient] = useState([])
    const { FormScreen } = Forms
    const { formState, setFormState } = FormScreen
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchSpecificAuthority, setLoadingFetchSpecificAuthority ] = useState(false)

    // 3. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({idauthority: ''})

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/legal/fetch-specific-authority/${paramsToSearch.idauthority}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idauthority > 0 ){
            setLoadingFetchSpecificAuthority(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idauthority: rows[0].idauthority || '',
                        nombre: rows[0].nombre || ''
                    }))
                    setLoadingFetchSpecificAuthority(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificAuthority(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificAuthority, setParamsToSearch, executeFetch }

}